//   ?token=TOKEN  → legacy Okta email-verify (existing flow, unchanged)
// After a successful guest verify the backend marks the session as verified so the
// polling loop in the sign-in tab (pollEmailVerification) can pick up the customAuthToken.
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@eagleview/ev-comp-library';
import { verifyGuestEmailTokenService } from '../../services/GuestAccess.service';
import { VERIFICATION_STATUS, EMAIL_VERIFY_STATUS } from '../../constants/GuestAccess';
import { guestFlowBaseStyles, guestFlowThemedStyles } from '../guest-access/guestFlow.styles';
import AuthSplitLayout, { SplitLayoutFooter } from '../auth-split-layout';

const useStyles = makeStyles((theme) => ({
  ...guestFlowBaseStyles,
  ...guestFlowThemedStyles(theme),
}));

/**
 * Email Verification Component
 * Displays email verification success page and triggers API call to verify email
 * #genai
 */
const EmailVerify = () => {
  const classes = useStyles();
  const location = useLocation();
  const [verificationStatus, setVerificationStatus] = useState(EMAIL_VERIFY_STATUS.VERIFYING); // 'verifying', 'success', 'error'

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const guestToken = params.get('t');

    if (guestToken) {
      verifyGuestEmailTokenService(guestToken)
        .then(({ ok, json = {} }) => {
          const isExpired = json.status === VERIFICATION_STATUS.EXPIRED
            || json.status === VERIFICATION_STATUS.EXPIRED_LC;
          setVerificationStatus(ok && !isExpired ? EMAIL_VERIFY_STATUS.SUCCESS : EMAIL_VERIFY_STATUS.ERROR);
        })
        .catch(() => {
          setVerificationStatus(EMAIL_VERIFY_STATUS.ERROR);
        });
    } else {
      setVerificationStatus(EMAIL_VERIFY_STATUS.ERROR);
    }
  }, [location.search]);

  return (
    <AuthSplitLayout footer={<SplitLayoutFooter />}>
      {verificationStatus === EMAIL_VERIFY_STATUS.VERIFYING && (
        <>
          <h1 className={classes.title}>Verifying Email...</h1>
          <p className={classes.body}>Please wait while we verify your email address.</p>
        </>
      )}
      {verificationStatus === EMAIL_VERIFY_STATUS.SUCCESS && (
        <>
          <h1 className={classes.title}>Email Verified!</h1>
          <p className={classes.body}>Your email has been verified. You can now close this tab.</p>
        </>
      )}
      {verificationStatus === EMAIL_VERIFY_STATUS.ERROR && (
        <>
          <h1 className={classes.title}>Unable to Verify Email</h1>
          <p className={classes.body}>
            This verification link is invalid or has expired, please
            {' '}
            <span
              role="button"
              tabIndex={0}
            >
              sign in again
            </span>
            {' '}
            to request a new link
          </p>
        </>
      )}
    </AuthSplitLayout>
  );
};

export default EmailVerify;
